import { Component, OnInit, Input } from "@angular/core"
import { Router } from "@angular/router"

import { FilterState } from "../../cadastro/admin/services/states/filter.state"
import { UserService } from "src/app/cadastro/admin/services/user.service"
import { LexTranslateService } from "@app/core/services/lex-translate.service"

@Component({
  selector: "[app-sidebar]",
  templateUrl: "./app-sidebar.component.html",
  styleUrls: ["./app-sidebar.component.css"],
})
export class AppSidebarComponent implements OnInit {
  @Input() collapsed: boolean

  currentRole: string
  separatorPosition: number

  constructor(
    private router: Router,
    private filterState: FilterState,
    private userService: UserService,
    private lextranslate: LexTranslateService
  ) {}

  async ngOnInit() {
    await this.lextranslate.loadTranslationsInFunctionOfTenant()

    this.userService.getUserInfo().subscribe(({ role }) => {
      this.currentRole = role
    })
  }

  get availableOptions() {
    if (this.currentRole === "conexia") {
      this.separatorPosition = 6
      return this.lextranslate.optionsAdmConexia
    } else {
      this.separatorPosition = 4
      return this.lextranslate.optionsAdmSchool
    }
  }

  getRoute(activatedRoute: string) {
    const currentRoute = this.router.url.split("/")
    const nextRoute = activatedRoute.split("/")
    if (currentRoute[1] !== nextRoute[1]) {
      this.filterState.resetState()
    }
  }
}
